// extracted by mini-css-extract-plugin
module.exports = {"rankText":"TheRankOverviewModal_rankText_3UaLC","playersOverviewText":"TheRankOverviewModal_playersOverviewText_2u1tc","scoreText":"TheRankOverviewModal_scoreText_2gHxJ"};